import DOMPurify from 'dompurify';

const emailSafeConfig = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'span',
    'div',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'strike',
    'ul',
    'ol',
    'li',
    'a',
    'img',
    'table',
    'thead',
    'tbody',
    'tr',
    'td',
    'th',
    'blockquote',
    'pre',
    'code',
    'hr',
  ],
  ALLOWED_ATTR: [
    'style',
    'class',
    'href',
    'target',
    'rel',
    'src',
    'alt',
    'width',
    'height',
    'border',
    'cellpadding',
    'cellspacing',
    'colspan',
    'rowspan',
  ],
  ALLOWED_URI_REGEXP:
    /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|data):|[^a-z]|[a-z+.-]+(?:[^a-z+.-:]|$))/i,
  KEEP_CONTENT: true,
};

export const sanitizeHtmlForEmail = (html, config = emailSafeConfig) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, config);
};

export const sanitizeHtml = (html, config) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, config);
};

export { emailSafeConfig };
